import styled from 'styled-components';

export const Container = styled.div`
  padding: 32px 24px;
  display: flex;
  flex-direction: column;
  max-height: 80vh;
  overflow: auto;
`;
